export type Locale = 'en' | 'lv' | 'ru';

export type BlogId =
  | 'independent_broker'
  | 'car_leasing'
  | 'home_credit'
  | 'business_loan'
  | 'consumer_loan'
  | 'credit_history'
  | 'rid_of_credits'
  | 'best_consumer_loan'
  | 'credit_limit';

export interface BlogRoute {
  id: BlogId;
  slug: Record<Locale, string>;
}

export const BLOG_ROUTES: BlogRoute[] = [
  {
    id: 'independent_broker',
    slug: {
      en: 'independent-broker',
      lv: 'kas-ir-neatkarigs-kredita-brokeris',
      ru: 'chto-takoye-nezavisimyy-kreditnyy-broker'
    }
  },
  {
    id: 'car_leasing',
    slug: { en: 'what-is-car-leasing', lv: 'kas-ir-auto-lizings', ru: 'kak-rabotaet-avtolizing' }
  },
  {
    id: 'home_credit',
    slug: { en: 'what-is-home-credit', lv: 'kas-ir-majokla-kredits', ru: 'chto-takoye-kredit-na-zhile' }
  },
  {
    id: 'business_loan',
    slug: { en: 'what-is-business-loan', lv: 'kas-ir-kredits-biznesam', ru: 'kak-rabotaet-biznes-kredit' }
  },
  {
    id: 'consumer_loan',
    slug: { en: 'what-is-consumer-loan', lv: 'kas-ir-paterina-kredits', ru: 'cho-potrebitelskiy-kredit' }
  },
  {
    id: 'credit_history',
    slug: {
      en: 'how-to-check-your-credit-history',
      lv: 'ka-uzzinat-savu-kreditvesturi',
      ru: 'kak-uznat-svoyu-kreditnuyu-istoriyu'
    }
  },
  {
    id: 'rid_of_credits',
    slug: {
      en: 'how-to-get-rid-of-credits',
      lv: 'ka-tikt-vala-no-kreditiem',
      ru: 'kak-izbavitsya-ot-kreditov'
    }
  },
  {
    id: 'best_consumer_loan',
    slug: {
      en: 'where-is-it-better-to-get-a-consumer-loan',
      lv: 'kur-izdevigak-nemt-paterina-kreditu',
      ru: 'gde-vygodnee-vzyat-potrebitelskiy-kredit'
    }
  },
  {
    id: 'credit_limit',
    slug: {
      en: 'how-much-can-i-borrow',
      lv: 'cik-lielu-kreditu-es-varu-panemt',
      ru: 'kakuyu-summu-kredita-ya-mogu-poluchit'
    }
  }
];
